import CompanyAutocomplete from '@/components/autocompletes/CompanyAutocomplete'

export const fleetRentalOrderStatuses = vm => [
  {
    text: vm.$gettext('Pending'),
    value: 'pending',
    variant: 'info'
  },
  {
    text: vm.$gettext('Assigned'),
    value: 'assigned',
    variant: 'warning'
  },
  {
    text: vm.$gettext('Confirmed'),
    value: 'confirmed',
    variant: 'success'
  },
  {
    text: vm.$gettext('Incidence'),
    value: 'incidence',
    variant: 'warning'
  },
  {
    text: vm.$gettext('Finished'),
    value: 'finished',
    variant: 'success'
  },
  {
    text: vm.$gettext('Cancelled'),
    value: 'canceled',
    variant: 'danger'
  }
]

// Quick filters de fleet rental orders (ex FleetRentalOrderList.vue).
// El consumidor debe llamar vm.fetchCountries() y vm.fetchRegions().
export default vm => ({
  filters: [
    {
      name: 'statuses',
      label: vm.$gettext('Statuses'),
      type: 'checkbox-group',
      options: () => fleetRentalOrderStatuses(vm),
      value: [],
      callback: val => (val.length > 0 ? [['status', 'in', val]] : [])
    },
    {
      name: 'expireds',
      label: vm.$gettext('Still open but expired'),
      type: 'checkbox',
      value: false,
      callback: val =>
        val
          ? {
              filters: [
                ['status', 'in', ['pending', 'assigned', 'confirmed', 'incidence']],
                ['date_to', 'lt', vm.moment.utc().format('YYYY-MM-DD HH:mm:ss')]
              ]
            }
          : []
    },
    {
      name: 'reference',
      label: vm.$gettext('Reference'),
      type: 'text',
      value: '',
      callback: val => (val.length > 0 ? [['reference', 'ct', val]] : [])
    },
    {
      name: 'company',
      label: vm.$gettext('Company'),
      type: 'autocomplete',
      component: CompanyAutocomplete,
      value: [],
      callback: val => (val.length > 0 ? [['company_id', 'in', val.map(item => item.id)]] : [])
    },
    {
      name: 'country',
      label: vm.$gettext('Country'),
      type: 'select',
      showIf: () =>
        vm.$store.getters.profile.roles.findIndex(x => x.name === vm.$roles.INTERNATIONAL) !== -1 &&
        Boolean(vm.$cookies.get('bypassCountry')),
      options: () => [
        { text: vm.$gettext('Select Country'), value: null },
        ...vm.countries.map(x => ({ value: x.iso_code, text: x.name }))
      ],
      value: null,
      callback: val => (val ? [['company.country_iso_code', 'eq', val]] : [])
    },
    {
      name: 'region',
      label: vm.$gettext('Region'),
      type: 'select',
      options: () => [{ text: vm.$gettext('All'), value: null }, ...(vm.regionsSelect || [])],
      value: null,
      callback: val => (val ? [['region_id', 'eq', val]] : [])
    },
    {
      name: 'inDateRange',
      label: vm.$gettext('In Date Range'),
      type: 'daterange',
      value: {
        startDate: vm.moment().subtract(6, 'day').startOf('day').toDate(),
        endDate: vm.moment().subtract(0, 'day').endOf('day').toDate(),
        active: 0
      },
      callback: val => {
        if (!val.active) {
          return []
        }
        const isRaw = date => typeof date === 'string' && date.length === 19
        const start = isRaw(val.startDate)
          ? vm.moment(val.startDate).utc()
          : vm.moment(val.startDate).startOf('day').utc()
        const end = isRaw(val.endDate) ? vm.moment(val.endDate).utc() : vm.moment(val.endDate).endOf('day').utc()
        return [
          ['date_from', 'gte', start.format('YYYY-MM-DD HH:mm:ss')],
          ['date_to', 'lte', end.format('YYYY-MM-DD HH:mm:ss')]
        ]
      }
    }
  ],
  layout: [
    {
      row: [
        { span: { cols: 12, md: 3 }, keys: ['statuses', 'expireds'] },
        { span: { cols: 3 }, keys: ['reference', 'company'] },
        { span: { cols: 3 }, keys: ['country', 'region', 'inDateRange'] }
      ]
    }
  ]
})
